<template>
  <div class="main">
    <h1>{{ page.pageTitle }}</h1>
    <div class="body">
      <template v-for="(p, key) in page.links">
        <p style="text-align: center" :key="key" v-if="p.key == 1">
          {{ p.value }}
        </p>
        <div :key="'2' + key" class="link" v-else-if="p.key == 2">
          {{ p.label }}：<a href="#" @click="goTo(p.value)" type="primary" disabled>{{ p.text }}</a>
        </div>
        <div :key="'3' + key" v-else-if="p.key == 3">
          <img :src="p.value" style="width: 100%" alt="" />
        </div>
        <div :key="'4' + key" v-else-if="p.key == 4">
          <video controls width="100%">
            <source :src="p.value" type="video/mp4" />
          </video>
        </div>
      </template>
    </div>
    <div v-if="page.buttons" class="footer">
      <div v-show="page.buttons.includes('1')" @click="$router.go(-1)">
        返回
      </div>
      <div v-show="page.buttons.includes('2')">再次验证</div>
      <div v-show="page.buttons.includes('3')">鉴定中心</div>
    </div>
  </div>
</template>

<script>
import { getH5Applet, listH5Applet } from '@/api/h5Applet'
import { listH5Pages } from '@/api/h5Pages'
export default {
  data() {
    return {
      appletForm: {},
      page: {},
      wks: ['wka', 'wkb', 'wkc', 'wkd', 'wke', 'wkrw', 'fqa'],
      wk2: ['kjza', 'kjzb', 'kjzc', 'lby', 'fqb', 'lbr', 'qya', 'qyb',]
    }
  },
  created() {
    console.log(this.$route.params)
    listH5Applet({ code: this.$route.params.company }).then(res => {
      if (res.rows.length > 0) {
        this.appletForm = res.rows[0]
        listH5Pages({ appletId: res.rows[0].appletId }).then(res => {
          let _page = res.data.find(item => { return item.pageType == 5 })
          let _links = JSON.parse(_page.links)
          document.title = res.data.name
          if (this.wks.includes(this.$route.params.company))
            this.$router.push({ path: '/wk', query: { pageId: _page.pageId, url: _links.find(item => { return item.key == 9 }) ? location.href : null, _u: location.href } })
          else if (this.wk2.includes(this.$route.params.company))
            if (!this.$route.params.code) {
              this.$router.push({ path: '/y2wm', query: { pageId: _page.pageId, url: _links.find(item => { return item.key == 9 }) ? location.href : null, _u: location.href } })
            }
            else {
              _page = res.data.find(item => { return item.pageType == 4 })
              _links = JSON.parse(_page.links)
              this.$router.push({ path: '/main', query: { pageId: _page.pageId, url: _links.find(item => { return item.key == 9 }) ? location.href : null, _u: location.href } })
            }
          else
            this.$router.push({ path: '/main', query: { pageId: _page.pageId, url: _links.find(item => { return item.key == 9 || item.key == 14 }) ? location.href : null, _u: location.href } })
        })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding: 0.32rem;

  .body {
    margin-top: 0.32rem;
  }
}

h1 {
  text-align: center;
  font-size: 0.56rem;
  padding: 0.32rem;
}

p {
  font-size: 0.44rem;
  line-height: 0.6rem;
  margin-bottom: 0.32rem;
}

.link {
  text-align: center;
  line-height: 1rem;
  font-size: 0.4rem;
}

a {
  text-decoration: none;
  color: #409eff;
}

.footer {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 48px;
  line-height: 48px;

  div {
    flex: 1;
    text-align: center;
    background: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/default.vue